module.exports = __webpack_public_path__ + "static/media/grandegp-mobile.b16f54a3.png";